import React, { FC, useMemo, useState } from "react"

import Button, { BUTTON_SIZES } from "@components/Button/Button"
import PlatformHeroGraphic from "./components/PlatformHeroGraphic/PlatformHeroGraphic"
import PlatformHeroTitle from "./components/PlatformHeroTitle/PlatformHeroTitle"
import Modal from "@components/Modal/Modal"
import PlayButton, { PLAY_BUTTON_SIZES } from "@components/PlayButton/PlayButton"
import { Wistia } from "@helpscout/hs-marketing-shared-components"

import { PlatformHeroHERO } from "./PlatformHero.styles"
import { BespokeComponentFragmentFragment } from "@graphqlTypes"

export type PlatformHeroJsonPayload = {
  titleFirstLine: string,
  nouns: string[],
  titleSecondLine: string,
  ctaText: string,
  wistiaId: string,
}

const PlatformHero: FC<{
  contentful_id: BespokeComponentFragmentFragment["contentful_id"],
  jsonPayload: BespokeComponentFragmentFragment["jsonPayload"],
}> = ({
  contentful_id,
  jsonPayload,
}) => {
    const json = useMemo(() => {
      try {
        return JSON.parse(jsonPayload?.internal.content || "") as PlatformHeroJsonPayload
      } catch (e) {
        console.error(`Failed to parse JSON Payload: PlatformHero (${contentful_id})`)
        return null
      }
    }, [jsonPayload])

    if (!json) return null

    const [isVideoModalOpen, setIsVideoModalOpen] = useState<boolean>(false)

    return (
      <>
        <PlatformHeroHERO className="PlatformHero">
          <div className="container padding-top--M margin-bottom--L">
            <div className="grid">
              <div className="column">
                <PlatformHeroTitle
                  nouns={json.nouns}
                  titleFirstLine={json.titleFirstLine}
                  titleSecondLine={json.titleSecondLine}
                />
              </div>
              <div className="buttons-wrapper column column-3-11-M column--4-10-L">
                <Button
                  className="watch-video"
                  onClick={() => setIsVideoModalOpen(true)}
                  size={BUTTON_SIZES.L}
                >
                  <>
                    <span dangerouslySetInnerHTML={{ __html: json.ctaText }} />
                    <PlayButton size={PLAY_BUTTON_SIZES.XS} />
                  </>
                </Button>
              </div>
            </div>
          </div>
          <PlatformHeroGraphic />
        </PlatformHeroHERO>
        {isVideoModalOpen && (
          <Modal
            onClose={() => setIsVideoModalOpen(false)}
            renderWithoutBox
          >
            <div className="WistiaPopover--Video">
              <Wistia autoPlay id={json.wistiaId} />
            </div>
          </Modal>
        )}
      </>
    )
  }

export default PlatformHero
